// PDF-LETÖLTÉS a partner-felületen — a Számláim lista és a havi áttekintés ugyanazt a folyamatot használja
// (a 2. fogyasztónál közös hookba került). A PDF base64-ben jön (sosem tárolódik): Blobbá dekódoljuk, és a
// böngésző mentés-párbeszéde viszi.
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

import { api } from '@/lib/api';

export function useInvoicePdf(): {
  /** A most letöltés alatt álló számla azonosítója (gomb-tiltáshoz). */
  downloading: string | null;
  download: (id: string) => Promise<void>;
} {
  const { t } = useTranslation();
  const [downloading, setDownloading] = useState<string | null>(null);

  const download = async (id: string): Promise<void> => {
    setDownloading(id);
    try {
      const res = await api.portal.invoicePdf.query({ params: { id } });
      if (res.status !== 200) {
        toast.error(t('toast:portal.pdfError'));
        return;
      }
      const bytes = Uint8Array.from(atob(res.body.contentBase64), (c) => c.charCodeAt(0));
      const url = URL.createObjectURL(new Blob([bytes], { type: 'application/pdf' }));
      const a = document.createElement('a');
      a.href = url;
      a.download = res.body.filename;
      a.click();
      URL.revokeObjectURL(url);
    } finally {
      setDownloading(null);
    }
  };

  return { downloading, download };
}
